import Vue from 'vue'
import App from './app.vue'

var VueTouch = require('vue-touch')
Vue.use(VueTouch, { name: 'v-touch' })
import AwesomePicker from 'vue-awesome-picker'
Vue.use(AwesomePicker)

// 计算自适应手机屏幕宽
var remSize = window.screen.width / 37.5 + 'px'
document.documentElement.style.fontSize = remSize

new Vue({
  el: '#app',
  render: h => h(App)
})
